;(function () {
  angular
    .module('contrast.applications.modals')
    .controller('AppMergeModalInstanceCtrl', AppMergeModalInstanceCtrl)

  function AppMergeModalInstanceCtrl(
    $scope,
    $filter,
    $uibModalInstance,
    logger,
    apps,
    ModuleFactory,
    ErrorService
  ) {
    'ngInject'

    $scope = angular.extend($scope, {
      apps: apps,
      model: {}
    })

    $scope = angular.extend($scope, {
      merge: merge,
      cancel: cancel
    })

    activate()

    function activate() {
      $scope.apps = apps.sort(function (a, b) {
        var an = a.name.toLowerCase()
        var bn = b.name.toLowerCase()
        if (an.name < bn.name) {
          return -1
        } else if (an.name > bn.name) {
          return 1
        }
        return 0
      })
      $scope.model.primary = $scope.apps[0]
    }

    function merge() {
      var primaryAppId = $scope.model.primary.app_id
      var filtered = $filter('diffByKey')(apps, primaryAppId, 'app_id')
      var params = {
        apps: filtered
      }
      ModuleFactory.merge(primaryAppId, params).then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
          $uibModalInstance.close(primaryAppId)
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
